import React from 'react';
import { motion } from 'framer-motion';
import styles from './OurStory.module.css';
import { FiCheckCircle } from 'react-icons/fi';

const OurStory = () => {
  // 1. Image Animation: 3D Flip effect
  const imageReveal = {
    hidden: { opacity: 0, rotateY: -20, scale: 0.9 },
    visible: {
      opacity: 1,
      rotateY: 0,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" }
    }
  };

  // 2. Text Card: Smooth Zoom and Fade
  const cardZoom = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8, ease: "backOut" }
    }
  };



  return (
    <section className={styles.container}>
      <motion.div
        className={styles.wrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >

        {/* Image Section - 3D Flip Entrance */}
        <motion.div
          className={styles.imageSection}
          variants={imageReveal}
          style={{ perspective: 1000 }}
        >
          <img
            src="/images/logo123.png"
            alt="Z Foundation Story"
            className={styles.mainImg}
          />
        </motion.div>

        <div className={styles.contentSection}>

          {/* Story Card - Combined with Mission */}
          <motion.div className={styles.storyCard} variants={cardZoom}>
            <h2 className={styles.title}>Our Story</h2>
            <h3 className={styles.subtitle}>A Journey of Kindness and Change</h3>
            <p className={styles.description}>
           Our mother raised us through many difficulties. Life was never easy, but she never gave up. With very little, she gave us everything she could—love, strength, and the belief that we should always help others, no matter our situation.After her passing, we felt the need to keep her spirit alive. In her memory, we want to start <strong>Z Foundation</strong> to support poor and needy people. This foundation is our way of giving back to society and continuing the kindness and values our mother lived by every day.
<strong>Z Foundation</strong> is not just a name—it is our promise to stand by those who need support, hope, and care.
            </p>

            <div className={styles.missionSection}>
              <h4 className={styles.boxTitle}>Our Mission</h4>
              <ul className={styles.missionList}>
                <li><FiCheckCircle className={styles.icon} /> Empower Women to rise</li>
                <li><FiCheckCircle className={styles.icon} /> Educate the Child</li>
                <li><FiCheckCircle className={styles.icon} /> End Hunger, One Meal</li>
                <li><FiCheckCircle className={styles.icon} /> Stand by people in Extreme Need</li>
              </ul>
            </div>
          </motion.div>
        </div>

      </motion.div>
    </section>
  );
};

export default OurStory;